<div class="content-document-info flip-vertical-left">
  <div class="image">
    <img src="assets/images/fingerprint.svg" alt="" id="generalImg1">
  </div>
  <div class="info">

    <div class="control-value">
      <p id="birthDateText"><strong>{{ copyService.copies.front_document_info_texts.birth_date_text }}</strong></p>
      <p id="userBirthDate" class="value">{{ documentInfo.birthdate }}</p>
    </div>

    <div class="control-value">
      <p id="genderText"><strong>{{ copyService.copies.front_document_info_texts.gender_text }}</strong></p>
      <p id="userGender" class="value">{{ documentInfo.sex }}</p>
    </div>

  </div>
</div>
<div class="subimage flip-vertical-left">
  <img src="assets/images/bar-code.svg" alt="" id="generalImg2">
</div>
